module.exports = {
  "indicator": {
    "position": "absolute",
    "itemColor": "rgba(255,195,0,0.5)",
    "itemSelectedColor": "#ffc300",
    "itemSize": "20",
    "height": "20",
    "bottom": "24"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-8863d6f2!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-lightbox/index.vue
// module id = 185
// module chunks = 0 1